import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import type { DevRoeUsesItem } from '#shared/lex'

type UsesItemValue = Omit<DevRoeUsesItem.Record, '$type'>

interface ItemEntry {
  rkey: string
  uri: string
  cid: string
  value: DevRoeUsesItem.Record
}

// `watch: false` stops useFetch firing one last `/.../undefined` request
// when `navigateTo` clears `route.params.rkey` on unmount.

export default /*@__PURE__*/_defineComponent({
  __name: '[rkey]',
  setup(__props) {

definePageMeta({ layout: false })
useHead({ title: 'Edit uses item - admin - Daniel Roe' })

const route = useRoute()
const rkey = computed(() => {
  const raw = route.params.rkey
  return typeof raw === 'string' && raw ? raw : null
})

if (!rkey.value) {
  throw createError({ status: 404, message: 'Missing rkey.' })
}

const { data, status } = useAdminFetch<ItemEntry>(`/api/admin/uses-items/${rkey.value}`, {
  watch: false,
})

async function save (value: UsesItemValue) {
  if (!rkey.value) return
  await $fetch(`/api/admin/uses-items/${rkey.value}`, { method: 'PUT', body: value })
  await navigateTo('/admin/uses')
}

return (_ctx: any,_cache: any) => {
  const _component_AdminUsesItemForm = _resolveComponent("AdminUsesItemForm")!
  const _component_AdminSkeletonForm = _resolveComponent("AdminSkeletonForm")!
  const _component_AdminShell = _resolveComponent("AdminShell")!

  return (_openBlock(), _createBlock(_component_AdminShell, { title: "Edit uses item" }, {
    default: _withCtx(() => [
      (_unref(data))
        ? (_openBlock(), _createBlock(_component_AdminUsesItemForm, {
            key: 0,
            initial: _unref(data).value,
            "submit-label": "Save",
            onSubmit: save
          }, null, 8, ["initial"]))
        : (_unref(status) === 'pending')
          ? (_openBlock(), _createBlock(_component_AdminSkeletonForm, {
              key: 1,
              fields: ['text', 'text', 'textarea', 'text', 'text'],
              "width-class": "max-w-2xl"
            }))
          : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})